import { formatLocalVersion } from '@w/utils'

declare global {
  // eslint-disable-next-line vars-on-top, no-var -- build-time bundler define
  var APP_VERSION: string
}

globalThis.APP_VERSION = formatLocalVersion(
  // The bundler `define` substitutes the bare `APP_VERSION` identifier with
  // an `{ appSha, sha, ts }` object. In contexts where define did not run (tests,
  // worker-tests via vitest-pool-workers) the identifier is unbound, so the
  // typeof guard avoids a ReferenceError.
  // oxlint-disable-next-line eslint-plugin-unicorn/no-typeof-undefined -- identifier may be unbound when bundler define did not run
  typeof APP_VERSION === 'undefined' ? undefined : APP_VERSION,
)

export function getFlashcardsAppVersionDisplay(): string {
  return globalThis.APP_VERSION
}

export function installReadableFlashcardsVersion(
  target?: FlashcardsVersionTarget,
): void {
  const readerTarget = target ?? resolveWindowTarget()
  if (!readerTarget) return

  Object.defineProperty(readerTarget, '__v', {
    configurable: true,
    get() {
      return `flashcards ${globalThis.APP_VERSION}`
    },
  })
}

function resolveWindowTarget(): FlashcardsVersionTarget | null {
  if (typeof window === 'undefined') return null
  return window
}

interface FlashcardsVersionTarget {
  __v?: string
}

declare global {
  interface Window extends FlashcardsVersionTarget {}
}
